import { Contact } from './contact';

export interface AddFuelSupplierContactRequest {
  fuelSupplierId: number;
  contacts: Contact[];
}
